export default __webpack_public_path__ + "static/media/O super.accf63da.svg";